import { Backdrop } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LoadingBackdrop = styled(Backdrop)`
  color: ${({ theme }) => theme.palette.common.white};
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`;
